import React from 'react';
import { ChangesModalFooterProps } from './types';

export const ChangesModalFooter = ({ children }: ChangesModalFooterProps): JSX.Element => {
  return <>{children}</>;
};
